var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigmaicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 67,
    viewBox: "0 0 45 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 67C17.46 67 22.5 61.9973 22.5 55.8333V44.6667H11.25C5.04 44.6667 0 49.6693 0 55.8333C0 61.9973 5.04 67 11.25 67Z",
    fill: "#0ACF83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 33.5C0 27.336 5.04 22.3333 11.25 22.3333H22.5V44.6667H11.25C5.04 44.6667 0 39.664 0 33.5Z",
    fill: "#A259FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.1667C0 5.00267 5.04 0 11.25 0H22.5V22.3333H11.25C5.04 22.3333 0 17.3307 0 11.1667Z",
    fill: "#F24E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H33.75C39.96 0 45 5.00267 45 11.1667C45 17.3307 39.96 22.3333 33.75 22.3333H22.5V0Z",
    fill: "#FF7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 33.5C45 39.664 39.96 44.6667 33.75 44.6667C27.54 44.6667 22.5 39.664 22.5 33.5C22.5 27.336 27.54 22.3333 33.75 22.3333C39.96 22.3333 45 27.336 45 33.5Z",
    fill: "#1ABCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaicon);
export default __webpack_public_path__ + "static/media/figmaicon.dd06084d95eea8bc7d2a857dd44c3354.svg";
export { ForwardRef as ReactComponent };